import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=eef11c9c&scoped=true"
import script from "./nodata.vue?vue&type=script&lang=js"
export * from "./nodata.vue?vue&type=script&lang=js"
import style0 from "./nodata.vue?vue&type=style&index=0&id=eef11c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef11c9c",
  null
  
)

export default component.exports